/**
 * AI turn input enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
/** Which of the two Claires ran the turn. */
export const aiTurnAgentLabels = {
    customer_chatbot: 'Customer chatbot',
    staff_assistant: 'Staff assistant',
};
export const aiTurnAgentValues = Object.keys(aiTurnAgentLabels);
//# sourceMappingURL=ai-turns.js.map